module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_02e.738f3237.jpg";